<div class="px-3 pt-3" *ngIf="showFilter">
  <mat-form-field class="w-100" appearance="fill">
    <mat-label>Search</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      type="text"
      (keyup)="onFilterData($event)"
      placeholder="Enter search keyword"
    />
  </mat-form-field>
</div>
<div class="table-responsive">
  <table
    mat-table
    #table
    [dataSource]="dataSource"
    class="w-100  rounded-3 newtable"
  >
  <!-- bg-light -->
    <!-- Image column template [OPTIONAL]-->
    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef>{{ 'misc.image' | translate }}</th>
      <td mat-cell *matCellDef="let rowObject">
        <ng-container
          *ngTemplateOutlet="imageTemplate; context: { $implicit: rowObject }"
        ></ng-container>
      </td>
    </ng-container>
    
    <!-- select column template [OPTIONAL]-->
 <ng-container matColumnDef="select">
  <th mat-header-cell *matHeaderCellDef>Select</th>
  <td mat-cell *matCellDef="let rowObject">
    <ng-container
      *ngTemplateOutlet="checkTemplate; context: { $implicit: rowObject }"
    ></ng-container>
  </td>
</ng-container>

    <!-- Dynamic column template -->
    <ng-container
      *ngFor="let column of columnHeaders"
      [matColumnDef]="column.columnProperty"
      
    >
      <th mat-header-cell *matHeaderCellDef>
        {{column.columnProperty != 'gst_collection' ? (column.columnName | titlecase) : column.columnName}}
      </th>
      <td mat-cell *matCellDef="let rowObject" class="text-capitalize" [ngClass]="getBookingStatusClass(rowObject[column.columnProperty], column.columnProperty)">
        <!-- <ng-container *ngIf="column.columnTemplate; else defaultTemplate">
          <ng-container
            *ngTemplateOutlet="column.columnTemplate; context: { row: rowObject, col: column }"
          ></ng-container>
        </ng-container> -->
        <ng-container
        *ngTemplateOutlet="
          column.columnTemplate ? column.columnTemplate : defaultTemplate;
          context: { row: rowObject, col: column }
        "
      ></ng-container>
        <ng-template #defaultContent let-rowValue="row" let-colValue="col">
          <div class="two-line-ellipsis">
            {{ rowObject[column.columnProperty] == 'bookingDate' ? (rowObject[column.columnProperty] | date) : 'jhjhj'  }}
            
          </div>
        </ng-template>
      </td>
      
    </ng-container>

   <ng-container matColumnDef="menu" stickyEnd>
  <th mat-header-cell *matHeaderCellDef></th>
  <td mat-cell *matCellDef="let rowObject" class="menu-cell werty">
    <div class="icon-wrapper">
      <button
        mat-icon-button
        aria-label="menu button"
        
      >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </td>
</ng-container>


    <!-- Row defination -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="rowClickHandler(row)"  class="clickable-row"></tr>

    <!-- Row shown when there is no matching data -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center" colspan="10">{{ 'misc.table_data_not_available' | translate }}</td>
    </tr>
  </table>
</div>
<mat-paginator
  [pageSize]="itemsPerPage"
  [length]="totalPageItems"
  *ngIf="showPagination"
></mat-paginator>

<ng-template #defaultTemplate let-rowValue="row" let-colValue="col">
  <div class="two-line-ellipsis">
  {{
    colValue.columnProperty === "creationDate" || colValue.columnProperty === "dob" || colValue.columnProperty === "expenseDatetime" || colValue.columnProperty === "last_payment_date" || colValue.columnProperty === "membership_start_date" || colValue.columnProperty === "date" || colValue.columnProperty === "creation_time" || colValue.columnProperty === 'bookingDate' || colValue.columnProperty === 'dateOfJoin'
    || colValue.columnProperty === 'use_date' || colValue.columnProperty === 'last_booking_date'  || colValue.columnProperty === 'fromDate' || colValue.columnProperty === 'booking_date' || colValue.columnProperty === 'toDate' || colValue.columnProperty === 'salaryCreditDate' || colValue.columnProperty === 'salaryFromDate' || colValue.columnProperty === 'aproxRepaymentDate'
      ? (rowValue[colValue.columnProperty] | date)
      : colValue.columnProperty === 'homeSales' || colValue.columnProperty === 'shopSales' || colValue.columnProperty === 'totalSales' || colValue.columnProperty === 'total_revenue' || colValue.columnProperty === 'amount' || colValue.columnProperty === 'total_revenue' || colValue.columnProperty === 'total_price' || colValue.columnProperty === 'profit' || colValue.columnProperty === 'total_expense' || colValue.columnProperty === 'total_revenue' || colValue.columnProperty === 'gst_collection' || colValue.columnProperty === 'other_tax' || colValue.columnProperty === 'service_tax' || colValue.columnProperty === 'total_tax' ? ((rowValue[colValue.columnProperty] )) : (colValue.columnProperty === "duty_time" ? (rowValue[colValue.columnProperty] | date : 'MMM d, y, h:mm a') : (colValue.columnProperty === "duty_date" ? (rowValue[colValue.columnProperty] | date : 'MMM d, y, h:mm a':'UTC') : rowValue[colValue.columnProperty]))  
  }}
  </div>
</ng-template>
